@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";

.heroAreaShell {
  height: 600px;
}

:host {
  --ha-pagination-color: white;
  --ha-pagination-inactive: rgba(255, 255, 255, 0.6);
  --ha-progress-fraction: 0;
}

.hero-swiper {
  width: 100%;
  max-width: 1380px;
  height: 100%;
  position: relative;

  --swiper-pagination-bullet-width: 96px;
  --swiper-pagination-bullet-height: 3px;
  --swiper-pagination-bullet-border-radius: 10px;
  --swiper-pagination-bullet-horizontal-gap: 8px;
  --swiper-pagination-bullet-inactive-color: var(--ha-pagination-inactive);
  --swiper-pagination-bullet-inactive-opacity: 0.8;
  --swiper-pagination-bullet-opacity: 1;

  --swiper-pagination-color:
    linear-gradient(
        to right,
        var(--ha-pagination-color),
        var(--ha-pagination-color)
      )
      left / calc(var(--ha-progress-fraction) * 100%) 100% no-repeat,
    var(--ha-pagination-inactive) left / 100% 100% no-repeat;
}

:host swiper-container::part(pagination) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  pointer-events: auto;
  height: 40px;
}

.hero-content {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  padding-bottom: 136px;
  width: 100%;
}

.text-button-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  > h2,
  > sdx-button-group,
  > .mouse-scroll-lottie {
    opacity: 1;
    transform: none;
  }

  > h2 {
    text-align: center;
    width: 100%;
    max-width: 100%;
  }
}

.mouse-scroll-lottie {
  height: 48px;
  margin: 0;
}

@keyframes slide-up-fade {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.text-button-content.ha-animate {
  > h2,
  > sdx-button-group,
  > .mouse-scroll-lottie {
    animation: slide-up-fade 1000ms cubic-bezier(0.31, 1, 0.64, 1) forwards;
    will-change: transform, opacity;
  }

  > h2 {
    animation-delay: 80ms;
  }

  > sdx-button-group,
  > .mouse-scroll-lottie {
    animation-delay: 200ms;
  }
}

@media (prefers-reduced-motion: reduce) {
  .text-button-content > h2,
  .text-button-content > sdx-button-group,
  .text-button-content > .mouse-scroll-lottie {
    animation: none !important;
    opacity: 1 !important;
    transform: none !important;
  }
}

scs-card-shell.ha-title-white {
  h2 {
    color: white !important;
  }
}
